<template lang="pug">
  div#workspace.clearfix.workspace
    div.column.split-left
      div#form.form
        slot(name="form")
  
    div.column.split-right.graph-paper
      div#rendered
        slot(name="render")
  
    div#clone(style="position: absolute; top: -5000px; left: -5000px")
</template>

<script>

  export default {

    props: ['workingTemplate'],
  }

</script>



// WEBPACK FOOTER //
// workspace.vue?0fa5c25e